import pullAt from 'lodash/pullAt'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const moveElementInArray = (array: any[], fromIndex: number, toIndex: number): any[] => {
  const isValidIndex = (index: number) => index >= 0 && index < array.length

  if (!isValidIndex(fromIndex) || !isValidIndex(toIndex)) {
    return array
  }

  const copyArray = [...array]
  const element = copyArray[fromIndex]
  pullAt(copyArray, fromIndex)
  copyArray.splice(toIndex, 0, element)
  return copyArray
}
